import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark-900" data-id="element-230">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-dark-800 via-dark-900 to-black opacity-80" data-id="element-231"></div>

      {/* Decorative Gold Lines */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-232">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold-500 to-transparent" data-id="element-233"></div>
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold-500 to-transparent" data-id="element-234"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-235">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-236">
          <div className="inline-block mb-6 px-4 py-1 border border-gold-500/30 rounded-full bg-gold-900/10 backdrop-blur-sm" data-id="element-237">
            <span className="text-gold-400 text-xs tracking-[0.2em] uppercase" data-id="element-238">
              Est. 2014 • Singapore
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium text-white mb-4 leading-tight" data-id="element-239">
            TTVIP-新加坡<span className="text-gold-500" data-id="element-240">顶级</span>伴游
          </h1>

          <h2 className="text-xl md:text-3xl font-light text-gold-200/80 tracking-widest uppercase mb-8 font-serif" data-id="element-241">
            Singapore's Premier Companion Platform
          </h2>

          <p className="max-w-2xl mx-auto text-gray-400 text-sm md:text-base leading-relaxed mb-12 font-light" data-id="element-242">
            十年专注，为您打造独一无二的尊贵体验。汇聚全球佳丽，尽享奢华时光。
            <br className="hidden md:block" data-id="element-243" />
            <span className="text-xs text-gray-600 mt-2 block uppercase tracking-wider" data-id="element-244">
              Ten years of excellence in crafting unique, luxurious experiences.
            </span>
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-245">
            <motion.a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-10 py-4 bg-gold-500 text-dark-900 font-medium tracking-widest uppercase hover:bg-gold-400 transition-colors shadow-[0_0_20px_rgba(212,175,55,0.3)] inline-block text-center" data-id="element-246">
              新加坡春风阁 | CFGE
            </motion.a>

            <motion.a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-10 py-4 border border-white/20 text-white font-light tracking-widest uppercase hover:border-gold-500/50 hover:text-gold-200 transition-colors inline-block text-center" data-id="element-247">
              Telegram 频道 | Channel
            </motion.a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center" data-id="element-248">
        <span className="text-[10px] text-gray-500 uppercase tracking-[0.3em] mb-2" data-id="element-249">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-250">
          <ChevronDown className="text-gold-500/50 w-6 h-6" data-id="element-251" />
        </motion.div>
      </motion.div>
    </section>;
}